<div class="carousel-container">
    <button *ngIf="images?.length > 1" mat-icon-button class="nav-button left" (click)="previousSlide()">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <img *ngIf="images" class="slide" [src]="images[currentIndex]" alt="Slide">
    <button *ngIf="images?.length > 1" mat-icon-button class="nav-button right" (click)="nextSlide()">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
  